import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["data-test-id"]

import { computed } from 'vue';
import { Text, RichText, Image, Field, ComponentFields, ComponentRendering } from '@sitecore-jss/sitecore-jss-vue';
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';

import { PanelTitleTypes } from '@/enums/panel-title-type.enum';
import { usePageStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'PanelTitle',
  props: {
    bindings: {},
    icon: {},
    title: {},
    subTitle: {},
    isTextBlock: {},
    fullWidth: { type: Boolean },
    panelType: {},
    dataTestId: {},
    fields: {},
    rendering: {},
    isTitleRichText: { type: Boolean }
  },
  setup(__props: any) {



const props = __props;

const outerClass = `${props.bindings?.outerClass ?? ''} ${props.rendering?.params?.Styles ?? ''}`.trim();
const inlineStyle = props.rendering?.params?.inlineStyle;
const dataTestId = usePageStore().dataTestId(
  props.rendering /** EE Rendering */ ?? { fields: props } /** Page builder */
);

const PANEL_TYPE_CLASS_MAP: Record<
  PanelTitleTypes,
  {
    imageWrapper: string;
    image: string;
    contentWrapper: string;
    title: string;
    subTitle: string;
  }
> = {
  [PanelTitleTypes.Display]: {
    imageWrapper: 'w-[64px] h-[64px]',
    image: 'w-[64px]',
    contentWrapper: props.isTextBlock?.value ? 'gap-3' : 'gap-2',
    title: props.isTextBlock?.value ? 'text-lg-bold' : 'text-xl2-bold',
    subTitle: props.isTextBlock?.value ? 'text-base' : 'text-lg',
  },
  [PanelTitleTypes.Primary]: {
    imageWrapper: 'flex justify-center w-[40px] h-[60px]',
    image: 'w-[40px]',
    contentWrapper: props.isTextBlock?.value ? 'gap-3' : 'gap-2',
    title: props.isTextBlock?.value ? 'text-lg-bold' : 'text-xl-bold',
    subTitle: 'text-base',
  },
  [PanelTitleTypes.Secondary]: {
    imageWrapper: 'w-[40px] h-[60px]',
    image: 'w-[40px]',
    contentWrapper: props.isTextBlock?.value ? 'gap-3' : 'gap-1',
    title: 'text-lg-bold',
    subTitle: 'text-base',
  },
  [PanelTitleTypes.Subheading]: {
    imageWrapper: 'w-[40px] h-[60px]',
    image: 'w-[40px]',
    contentWrapper: props.isTextBlock?.value ? `gap-3` : 'gap-1',
    title: props.isTextBlock?.value ? 'text-lg-bold' : 'text-base-bold uppercase',
    subTitle: props.isTextBlock?.value ? 'text-base' : 'text-m pb-2',
  },
};

const classList = computed(() => {
  let list = [];
  list.push((props.fields?.fullWidth ?? props.fullWidth) ? 'w-full' : 'text-block');
  list.push(normalizedType.value == PanelTitleTypes.Display ? 'flex-col md:flex-row' : '');
  return list;
});

const normalizedType = computed<PanelTitleTypes>(() => {
  const raw = (props.fields?.panelType ?? props.panelType)?.value?.trim() || '';
  switch (raw.toLowerCase()) {
    case 'display':
      return PanelTitleTypes.Display;
    case 'primary':
      return PanelTitleTypes.Primary;
    case 'secondary':
      return PanelTitleTypes.Secondary;
    case 'subheading':
      return PanelTitleTypes.Subheading;
    default:
      return PanelTitleTypes.Primary;
  }
});

const classesByType = computed(() => PANEL_TYPE_CLASS_MAP[normalizedType.value]);
const imageWrapperClasses = computed(() => classesByType.value.imageWrapper);
const imageClasses = computed(() => classesByType.value.image);
const contentClasses = computed(() => classesByType.value.contentWrapper);
const titleClasses = computed(() => classesByType.value.title);
const subTitleClasses = computed(() => classesByType.value.subTitle);

const showIcon = computed(() => {
  return (
    (props.fields?.icon ?? props.icon)?.value?.src &&
    !props.isTextBlock?.value &&
    normalizedType.value != PanelTitleTypes.Subheading
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(outerClass)),
    style: _normalizeStyle(_unref(inlineStyle)),
    "data-test-id": _unref(dataTestId)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["justify-start gap-4 inline-flex", classList.value])
    }, [
      (showIcon.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["block", imageWrapperClasses.value])
          }, [
            _createVNode(_unref(Image), {
              media: _ctx.fields?.icon ?? _ctx.icon,
              class: _normalizeClass(imageClasses.value)
            }, null, 8, ["media", "class"])
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["grow shrink basis-0 flex-col justify-start items-start inline-flex", contentClasses.value])
      }, [
        (_ctx.fields?.title?.value ?? _ctx.title?.value)
          ? (_openBlock(), _createElementBlock("h3", {
              key: 0,
              class: _normalizeClass(["self-stretch text-racq-dark-grey", titleClasses.value])
            }, [
              (_ctx.isTitleRichText)
                ? (_openBlock(), _createBlock(_unref(RichText), {
                    key: 0,
                    field: _ctx.fields?.title ?? _ctx.title
                  }, null, 8, ["field"]))
                : (_openBlock(), _createBlock(_unref(Text), {
                    key: 1,
                    field: _ctx.fields?.title ?? _ctx.title
                  }, null, 8, ["field"]))
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.fields?.subTitle?.value ?? _ctx.subTitle?.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["self-stretch text-racq-med-grey richtext", subTitleClasses.value])
            }, [
              _createVNode(_unref(RichText), {
                field: _ctx.fields?.subTitle ?? _ctx.subTitle
              }, null, 8, ["field"])
            ], 2))
          : _createCommentVNode("", true)
      ], 2)
    ], 2)
  ], 14, _hoisted_1))
}
}

})